import React from 'react';
import {
  TextInput,
  Filter,
  ReferenceInput,
  SelectInput,
  DateInput,
} from 'react-admin';

const StudentsFilter = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Filter {...props} data-testid="clients-filters">
    <TextInput key="filter01" label="ra.action.search" source="q" alwaysOn />
    <TextInput key="filterPlatform" label="Plataforma" source="platform_id" />
    <ReferenceInput
      label="Clientes"
      source="courseId.clientId"
      reference="clients"
      perPage={90000}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      label="Licencias"
      source="courseId.licenseId.id"
      reference="licenses"
      perPage={90000}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput
      label="Cursos"
      source="courseId.id"
      reference="courses"
      perPage={90000}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <DateInput source="createdAt" label="Fecha inicio" />
    <DateInput source="updatedAt" label="Fecha fin" />
  </Filter>
);

export default StudentsFilter;
